import {
  BpView,
  hasBpPartnerInfo,
} from '@/components/Approval/@components/BusinessPartnerRegistration';
import { parseBpContent } from '@/utils/approval/businessPartnerRegistration';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 200·201 거래처 신규/변경 HK·TW — 레거시 조회처럼 저장 content 그대로. '변경'은 업체소싱정보가 없어 숨김 */
const BpRegistrationSlot = ({ data }: ContentExtraProps) => {
  const content = parseBpContent(data.attributes);
  if (!content || !hasBpPartnerInfo(content)) return null;
  return (
    <ContentSlotRoot>
      <BpView content={content} />
    </ContentSlotRoot>
  );
};

export default BpRegistrationSlot;
